import { Injectable } from "@angular/core";
import { HttpService } from "./http-service";
import { Router } from "@angular/router";
import { Http, Headers, RequestOptions } from "@angular/http";
import { ToastrService } from "ngx-toastr";
import { map } from "rxjs/operators";
import { Configuracoes } from "../entities/configuracoes";

@Injectable({
  providedIn: "root",
})
export class CnpjService extends HttpService {
  constructor(
    public router: Router,
    public http: Http,
    public toastService: ToastrService
  ) {
    super(http, toastService);
  }

  getCnpjAPIAgilb2b(cnpj: string, callback) {
    cnpj = cnpj.replace(".", "").replace(".", "");
    cnpj = cnpj.replace("/", "");
    cnpj = cnpj.replace("-", "");
    this.showLoading();
    let url = Configuracoes.API + "consultacnpj?cnpj=" + cnpj;
    this.http
      .get(url, this.getHttpOptionsCnpj())
      .pipe(map((resp) => resp.json()))
      .subscribe(
        (resp) => {
          callback(resp);
          this.dimissLoading();
        },
        (error) => {
          this.dimissLoading();
          this.toastService.info("Não foi possivel consultar CNPJ", "", {
            timeOut: 4000,
          });
        }
      );
  }

  getHttpOptionsCnpj() {
    var header = new Headers({
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.getToken(),
      Branch:Configuracoes.API_BRANCH
    });
    return new RequestOptions({
      headers: header,
    });
  }

  getToken() {
    return window.localStorage.getItem("token");
  }

}
